import { Container } from './styled';
import React from 'react';
import { Text } from 'mol-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

const SkipToContent = () => {
    
    const { primaryColor } = useTheme();
    const { t } = useTranslation();
    
    return (
        <Container href="#content">
            <Text color={ primaryColor }>
                { t('Saltar al contenido') }
            </Text>
        </Container>
    );
};

SkipToContent.propTypes = {

};

export default SkipToContent;
